import { create } from "zustand";

interface DetailsSectionStore {
  resetDetailsSection: boolean;
  isLoading: boolean;
  setResetDetailsSection: (reset: boolean) => void;
  setIsLoading: (loading: boolean) => void;
}

export const useDetailsStore = create<DetailsSectionStore>()((set) => ({
  resetDetailsSection: false,
  isLoading: false,
  setResetDetailsSection: (reset) => set({ resetDetailsSection: reset }),
  setIsLoading: (loading) => set({ isLoading: loading })
}));
